import React from 'react';
import TextField from 'material-ui/TextField';
import styles from 'styles/components/lib/tables/dnd/dndTextInput.css';

export default class DnDTextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      hasError: props.hasError,
      isEditing: props.isEditing
    };
  }
  componentDidMount() {
      if (this.props.isEditing) {
	      window.addEventListener( 'click', this.handleClickOut );
      }
      // let input = this.refs.groupName;
	  // console.log('>>>DIDMOUNT, ISEIDITNG >>>  ', this.props.isEditing, this.props.name );
     //  if (input) input.focus();


  }

  componentWillReceiveProps(nProps) {

    if (nProps.name !== this.props.name) {
      this.setState({name: nProps.name});
    }
    if (nProps.isEditing !== this.props.isEditing) {

	    // console.log('>>>#### NPROPS', nProps.isEditing, this.props.isEditing, this.state.isEditing );

      if (!this.props.isEditing) {
	      window.addEventListener( 'click', this.handleClickOut );
      }
      this.setState({ isEditing: nProps.isEditing, name: nProps.name });
    }
    if (nProps.hasError !== this.props.hasError &&
      nProps.hasError !== this.state.hasError) this.setState({ hasError: nProps.hasError });
  }

  componentWillUnmount() {
	  if (this.props.isEditing) {
		  window.removeEventListener( 'click', this.handleClickOut );
	  }
  }

  handleBlur = (e) => { // console.log('>>>HANDLE BLUR', e);
    this.props.onSubmit('name', this.state.name)
  }

  handleChange = (e) => { // console.log('handleCHANGE');
    this.setState({
      name: e.target.value,
      hasError: false });
    if (this.props.errorMessage && !this.props.isNewBucket) this.props.clearError(true);
    this.props.handleEmptyName(e.target.value);
    if( this.props.isNewBucket ) this.props.onNewNameChange(e.target.value);
  }

  handleClick = (e) => {
    e.stopPropagation();
    if (!this.state.isEditing) this.props.toggleRow();
    // this.setState({ isEditing: true });
  }

  handleFocus = (e) => { // console.log('>>>HANDLE FOCUS');
    if (e) e.stopPropagation();
  }

  handleClickOut = (e) => { // console.log('>>>HANDLE CLICKOUT');
    // if (this.state.isEditing && !this.props.isNewBucket) this.setState({isEditing: false});
  }

  handleKeyPress = (e) => { // console.log('>>>HANDLE KEY PRESS');
    if (e.key === 'Enter') this.props.onSubmit('name', this.state.name);
  }

  render() {
    let { hasError, isEditing, name } = this.state;
    let { col, hintText, row, style, isNewBucket, errorMessage  } = this.props;
    let inputStyle;
    let underlineStyle={borderColor: `${row.color}`};

    if (!isEditing) {
        name = this.props.name;
        inputStyle = {
          WebkitTextFillColor: '#454443',
          width: `${this.props.isTouchDevice ? '100%' : '256px'}`,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis' };
        underlineStyle = {
          opacity: '0',
          transition: 'all 0.3s ease'};
    }
    if (hasError || errorMessage) underlineStyle={ color: 'red', transition: 'all 0.3s ease' };
    let errorText = hasError
      ? "Name is required"
      : errorMessage ? errorMessage : null
    //ref={(input) => input && input.focus()}
    return (
      <li className={styles.textInputContainer}
          title={name.toUpperCase()}
          style={style} >
        { isEditing ?
          (
            <TextField
                       autoFocus={true}
                       className={!isEditing ? styles.textInputDisabled : styles.textInput}
                       disabled={this.props.isTouchDevice ? !isEditing : false}
                       errorText={errorText}
                       hintText={hintText}
                       id="groupName"
                       inputStyle={inputStyle}
                       onClick={this.handleClick}
                       onFocus={this.handleFocus}
                       onBlur={ isEditing || !isNewBucket  ? this.handleBlur : undefined}
                       onChange={isEditing ? this.handleChange : undefined}
                       onKeyPress={isEditing ? this.handleKeyPress : undefined}
                       style={{height: '40px', outline: !isEditing ? 'none' : 'initial'}}
                       underlineFocusStyle={{borderColor: `${row.color}`}}
                       underlineStyle={isEditing ? underlineStyle : {display: 'none'}}
                       value={name} />
          ) : (
            <h5 className={styles.textInputDisabled} style={inputStyle}>{name}</h5>
          )
        }
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/lib/tables/dnd/DnDTextInput.js